import { AppCard } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { VendorProfileDetails } from "./-internal_components/VendorProfileDetails";
import { Route as VendorRoute } from "./route";

const RouteComponent: React.FC = () => {
  const vendor = VendorRoute.useLoaderData();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <AppCard>
        <VendorProfileDetails vendor={vendor} />
      </AppCard>
    </Box>
  );
};

export const Route = createFileRoute("/_private/vsupplierregistration/vendor/")(
  {
    component: RouteComponent,
  },
);
